<template>
  <div id="default-layout">
    <slot />
    <Alert
      :snackbar="snackbar"
      :type="alertType"
      :text="alertText"
      @close="onCloseAlert"
    />
    <div v-show="isLoading" class="loading-process">
      <v-progress-circular indeterminate color="light-blue darken-1" />
    </div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";

import Alert from "@/components/Alert.vue";

import Utils from "@/mixin";

export default {
  mixins: [Utils],
  components: {
    Alert,
  },
  computed: {
    snackbar() {
      return !isEmpty(this.alert?.message) ? true : false;
    },
    alertText() {
      return !isEmpty(this.alert) ? this.alert?.message : "";
    },
    alertType() {
      return !isEmpty(this.alert) ? this.alert?.type : "";
    },
  },
  methods: {
    onCloseAlert() {
      this.alert.message = "";
    },
  },
};
</script>

<style lang="scss" scoped>
#default-layout {
  min-height: 100vh;
  position: relative;
  .loading-process {
    z-index: 999;
    position: fixed;
    height: 100%;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.3);
    > div {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>